'use client'

import React from 'react'
import { Box, Typography } from '@mui/material'

import { Holiday } from '@/src/constants/holidayCalendarConfig'

interface HolidayCarouselProps {
    holidays: Holiday[]
    onHolidayClick: (holiday: Holiday) => void
}

const HolidayCarousel: React.FC<HolidayCarouselProps> = ({
    holidays,
    onHolidayClick
}) => {

    if (!holidays || holidays.length === 0) {
        return null
    }

    return (
        <Box
            sx={{
                p: 1,
                bgcolor: '#eff6ff',
                borderBottom: '1px solid',
                borderColor: 'divider'
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    gap: 1.5,
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    scrollBehavior: 'smooth',
                    WebkitOverflowScrolling: 'touch',
                    '&::-webkit-scrollbar': {
                        display: 'none'
                    },
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none'
                }}
            >
                {holidays.map((holiday) => (
                    <Box
                        key={holiday.id}
                        onClick={() => onHolidayClick(holiday)}
                        sx={{
                            flexShrink: 0,
                            minWidth: 'fit-content',
                            maxWidth: 160,
                            p: 1.5,
                            borderRadius: 2,
                            bgcolor: 'background.paper',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                opacity: 0.9
                            },
                            '&:active': {
                                transform: 'scale(0.98)'
                            }
                        }}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                fontSize: 16,
                                fontWeight: 600,
                                color: 'text.primary',
                                mb: 0.5,
                                lineHeight: 1.2
                            }}
                        >
                            {holiday.displayDate}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                fontSize: 13,
                                fontWeight: 400,
                                color: 'text.secondary',
                                lineHeight: 1.2
                            }}
                        >
                            {holiday.title}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export { HolidayCarousel }
export type { HolidayCarouselProps }

